import { render, staticRenderFns } from "./FileUpload2.vue?vue&type=template&id=8a3818d8&"
import script from "./FileUpload2.vue?vue&type=script&lang=js&"
export * from "./FileUpload2.vue?vue&type=script&lang=js&"
import style0 from "./FileUpload2.vue?vue&type=style&index=0&id=8a3818d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports